module.exports = __webpack_public_path__ + "static/media/SV5.a469e7f0.jpg";